import React from 'react';

import { Input, Form, Col, Row } from 'antd';

import { AutoCompleteAddressInput, Countries, States, AddressProps } from '@partsbadger/library';
import { observer } from 'mobx-react-lite';

interface IProps {
    form: any;
    defaultAddressName?: string;
    address?: AddressProps;
    addressType?: 'Billing' | 'Shipping' | 'Billing and Shipping';
}

const AddressFormSimple: React.FC<IProps> = props => {
    const labelAddressName = 'Full Name or Company';

    const fieldName = (name: string) => {
        return `${props?.addressType?.toLocaleLowerCase()}_${name}`;
    };

    return (
        <>
            <Col md={12} span={24}>
                <Form.Item
                    name={fieldName('name')}
                    label={labelAddressName}
                    rules={[
                        {
                            required: true,
                            message: `Name field is required.`,
                        },
                    ]}
                    // initialValue={props.address?.name ?? props.defaultAddressName}
                >
                    <Input />
                </Form.Item>
            </Col>

            <Col md={12} span={24}>
                <Form.Item
                    name={fieldName('phone')}
                    label={'Phone'}
                    rules={[
                        {
                            required: props?.addressType === 'Billing',
                            message: `Phone field is required.`,
                        },
                    ]}
                    // initialValue={props.address?.name ?? props.defaultAddressName}
                >
                    <Input />
                </Form.Item>
            </Col>

            <Col md={12} span={24}>
                <Form.Item
                    name={fieldName('street')}
                    label={'Street'}
                    rules={[
                        {
                            required: true,
                            message: `Street field is required.`,
                        },
                    ]}
                    initialValue={props.address?.street}
                >
                    <Input />
                </Form.Item>
            </Col>

            <Col md={12} span={24}>
                <Form.Item
                    name={fieldName('city')}
                    label={'City'}
                    rules={[
                        {
                            required: true,
                            message: `City field is required.`,
                        },
                    ]}
                    initialValue={props.address?.city}
                >
                    <Input />
                </Form.Item>
            </Col>
            <Col md={12} span={24}>
                <Form.Item noStyle dependencies={[fieldName('state')]}>
                    {({ getFieldValue }) => {
                        return (
                            <Form.Item
                                name={fieldName('state')}
                                label={'State'}
                                rules={[
                                    {
                                        required: true,
                                        message: `State field is required.`,
                                    },
                                ]}
                                initialValue={
                                    props.address?.state
                                        ? {
                                              key: props?.address.state,
                                              label: props?.address.state,
                                          }
                                        : null
                                }
                            >
                                <States countryShortCode={'US'} />
                            </Form.Item>
                        );
                    }}
                </Form.Item>
            </Col>
            <Col xs={24} md={12}>
                <Form.Item
                    label={'Zip Code'}
                    name={fieldName('zip_code')}
                    rules={[
                        {
                            required: true,
                            min: 5,
                            message: `Zip Code field is required.`,
                        },
                    ]}
                    initialValue={props.address?.zip_code}
                >
                    <Input />
                </Form.Item>
            </Col>
        </>
    );
};

export default observer(AddressFormSimple);
